import { IModelRaw } from './base';

export enum EUserRoles {
  Admin = 'admin',
  Editor = 'editor',
}

export interface IUser extends IModelRaw {
  name: string | null;
  email: string;
  picture: string | null;
  role: EUserRoles;
  organization: string | null;
  organizationRole: string | null;
  phone: string | null;
  lastName: string | null;
  password?: string | null;
  subscribe_investor?: boolean;
  subscribe_startup?: boolean;
  subscribe_researcher?: boolean;
}
